import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { PresetColorPicker, ReactSparkSelectInput } from '../../../widgets/index';
import * as ActionTypes from '../../../../constants/ActionTypes';
import { actions as ThemeActions } from '../../../../store/ThemeStore';
import * as GlobalActions from '../../../../actions/global';
import { fontWeights } from '../../../../constants/availableFonts';
import FontConfigurator from '../../../widgets/FontConfigurator/FontConfigurator';
import CSSLength from '../../../../../lib/css-property-parser/CSSLength';

const FontPropertyInput = ({ label, values, defaultValue, onChange, isDisabled }) => {
    return (
        <div className="col-xs-12 col-sm-4">
            <ReactSparkSelectInput
                label={label}
                onChange={onChange}
                isDisabled={isDisabled}
                defaultValue={defaultValue}
                values={values.map(v => {
                    return { key: v.toString(), label: v.toString() };
                })}
            />
        </div>
    );
};

class GlobalStyles extends Component {
    render() {
        const fontSize1 = new CSSLength(this.props.fontData.fontSize, {
            base: 16,
            formatter: (value, unit) => value + unit
        });
        const fontSize2 = fontSize1.px;
        const fontSize3 = Math.round(fontSize2.substring(0, fontSize2.length - 2)) + 'px';
        return (
            <div className="GlobalStyles">
                <div className="spark-panel__content col-lg-12 col-xs-12 col-sm-6">
                    <h4>{this.props.tagNameName}</h4>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <FontConfigurator
                                fontFamilyProperty={`${this.props.themePropPath}.fontFamily`}
                                fontWeightProperty={`${this.props.themePropPath}.fontWeight`}
                                fontWeightClass="col-lg-3 col-xs-12 col-sm-8"
                            >
                                <FontPropertyInput
                                    label="Font Size"
                                    defaultValue={fontSize3}
                                    values={this.props.availableFontSizes}
                                    isDisabled={this.props.isDisabled}
                                    onChange={this.props.onFontSizeChange(this.props.tagName)}
                                />
                                {this.props.tagName !== 'smallBody' ? (
                                    <FontPropertyInput
                                        label="Text-Transform"
                                        defaultValue={this.props.fontData.textTransform}
                                        isDisabled={this.props.isDisabled}
                                        values={['uppercase', 'lowercase', 'capitalize', 'none']}
                                        onChange={this.props.onTextDecorationChange(this.props.tagName)}
                                    />
                                ) : null}
                                <FontPropertyInput
                                    label="Line Height"
                                    defaultValue={this.props.fontData.lineHeight}
                                    isDisabled={this.props.isDisabled}
                                    values={this.props.availableLineHeight}
                                    onChange={this.props.onLineHeightChange(this.props.tagName)}
                                />

                                <div className="col-xs-12 col-sm-4">
                                    <PresetColorPicker
                                        color={this.props.fontData.color}
                                        isDisabled={this.props.isDisabled}
                                        onColorChange={this.props.onFontColorChange(this.props.tagName)}
                                    />
                                </div>
                            </FontConfigurator>
                        </div>
                        <div className="col-xs-12 col-sm-1" />
                        <div className="col-xs-12 col-sm-3">
                            <p
                                style={{
                                    fontFamily: this.props.fontData.fontFamily,
                                    lineHeight: this.props.fontData.lineHeight,
                                    textTransform: this.props.fontData.textTransform,
                                    fontStyle: this.props.fontData.style,
                                    color: this.props.fontData.color,
                                    fontWeight: this.props.fontData.fontWeight,
                                    fontSize: fontSize3,
                                    textAlign: this.props.fontData.align
                                }}
                            >
                                {this.props.sampleText}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

GlobalStyles.propTypes = {
    children: PropTypes.element,
    settings: PropTypes.object,
    tagNameName: PropTypes.string,
    sampleText: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool
};

const mapStateToProps = state => {
    return { ...state.theme.global };
};

const mapDispatchToProps = dispatch => {
    return {
        onFontChange: tagName => {
            return event => dispatch(ThemeActions.setGlobalFont(tagName, event.target.value));
        },
        onFontSizeChange: tagName => {
            return event => dispatch(GlobalActions.setGlobalFontSize(tagName, event.target.value));
        },
        onFontWeightChange: tagName => {
            return event => dispatch(GlobalActions.setGlobalFontWeight(tagName, event.target.value));
        },
        onFontColorChange: tagName => {
            return event => dispatch(GlobalActions.setGlobalFontColor(tagName, event.target.value));
        },
        onFontStyleChange: tagName => {
            return event => dispatch(GlobalActions.setGlobalFontStyle(tagName, event.target.value));
        },
        onTextDecorationChange: tagName => {
            return event => dispatch(GlobalActions.setTextDecoration(tagName, event.target.value));
        },
        onLineHeightChange: tagName => {
            return event => dispatch(GlobalActions.setLineHeight(tagName, event.target.value));
        },
        onTextAlignChange: tagName => {
            return event => dispatch(GlobalActions.setTextAlignment(tagName, event.target.value));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalStyles);



// WEBPACK FOOTER //
// ./src/components/pages/theme/global/Styles.js